import React from 'react';
import { 
  X, 
  Check, 
  MousePointer, 
  Edit3, 
  Move, 
  Plus, 
  Trash2, 
  Settings, 
  Clock, 
  Calendar, 
  Save, 
  Download, 
  Upload, 
  Image, 
  Palette,
  Printer,
  FileText,
  GripVertical,
  Eye,
  Copy
} from 'lucide-react';

const HelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content max-w-5xl max-h-[90vh] rounded-xl">
        <div className="modal-header bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-t-xl relative">
          <div className="flex items-center">
            <FileText size={24} className="mr-3" />
            <h2 className="modal-title text-white">AiQiji课程表制作 - 使用说明</h2>
          </div>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors duration-200 p-2 rounded-full hover:bg-white/20 flex items-center justify-center"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="modal-body max-h-[calc(90vh-140px)] overflow-y-auto p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            
            {/* 左侧列 */}
            <div className="space-y-6">
              
              {/* 基本操作 */}
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200">
                <div className="flex items-center mb-4">
                  <MousePointer className="text-blue-600 mr-3" size={20} />
                  <h3 className="text-blue-800 text-xl font-bold">基本操作</h3>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Edit3 className="text-green-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">点击编辑</p>
                      <p className="text-sm text-gray-600">点击课程表标题、时间格子或课程名称进行编辑</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Move className="text-purple-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">拖拽移动</p>
                      <p className="text-sm text-gray-600">拖拽课程到时间格子中，或拖拽课程调整位置</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <GripVertical className="text-orange-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">右键菜单</p>
                      <p className="text-sm text-gray-600">右键点击时间、星期或课程查看更多操作选项</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 课程管理 */}
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200">
                <div className="flex items-center mb-4">
                  <Settings className="text-green-600 mr-3" size={20} />
                  <h3 className="text-green-800 text-xl font-bold">课程管理</h3>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Plus className="text-green-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">添加课程</p>
                      <p className="text-sm text-gray-600">点击"添加课程"按钮，设置课程名称和颜色</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Eye className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">课程详情</p>
                      <p className="text-sm text-gray-600">点击"课程详情"查看和编辑所有课程信息</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Copy className="text-purple-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">批量管理</p>
                      <p className="text-sm text-gray-600">批量添加、删除和编辑多个课程</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Trash2 className="text-red-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">删除课程</p>
                      <p className="text-sm text-gray-600">右键点击课程或使用批量管理删除</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 时间管理 */}
              <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-6 rounded-xl border border-orange-200">
                <div className="flex items-center mb-4">
                  <Clock className="text-orange-600 mr-3" size={20} />
                  <h3 className="text-orange-800 text-xl font-bold">时间管理</h3>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Plus className="text-orange-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">添加时间</p>
                      <p className="text-sm text-gray-600">点击"时间管理"添加新的时间段</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Calendar className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">添加星期</p>
                      <p className="text-sm text-gray-600">点击"添加星期"增加更多日期列</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Move className="text-purple-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">拖拽排序</p>
                      <p className="text-sm text-gray-600">在时间管理中拖拽调整时间段顺序</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Edit3 className="text-green-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">编辑时间</p>
                      <p className="text-sm text-gray-600">点击时间格子直接编辑时间段</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 右侧列 */}
            <div className="space-y-6">
              
              {/* 背景设置 */}
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl border border-purple-200">
                <div className="flex items-center mb-4">
                  <Image className="text-purple-600 mr-3" size={20} />
                  <h3 className="text-purple-800 text-xl font-bold">背景设置</h3>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Image className="text-purple-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">背景图片</p>
                      <p className="text-sm text-gray-600">上传JPG、PNG、GIF、WebP格式图片（最大5MB）</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Palette className="text-pink-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">纯色背景</p>
                      <p className="text-sm text-gray-600">选择纯色背景，使用颜色选择器自定义</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Settings className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">透明度与模糊</p>
                      <p className="text-sm text-gray-600">调整背景图片的透明度和模糊效果</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 数据管理 */}
              <div className="bg-gradient-to-br from-indigo-50 to-blue-50 p-6 rounded-xl border border-indigo-200">
                <div className="flex items-center mb-4">
                  <Save className="text-indigo-600 mr-3" size={20} />
                  <h3 className="text-indigo-800 text-xl font-bold">数据管理</h3>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Save className="text-indigo-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">保存到本地</p>
                      <p className="text-sm text-gray-600">自动保存到浏览器本地存储</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Download className="text-green-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">导出数据</p>
                      <p className="text-sm text-gray-600">导出JSON文件，包含所有课程和设置</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Upload className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">导入数据</p>
                      <p className="text-sm text-gray-600">从JSON文件导入课程表和所有设置</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Image className="text-purple-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">导出图片</p>
                      <p className="text-sm text-gray-600">将课程表导出为高清PNG图片</p>
                    </div>
                  </div>
                  <div className="flex items-start bg-white p-3 rounded-lg shadow-sm">
                    <Printer className="text-gray-600 mr-3 mt-1 flex-shrink-0" size={16} />
                    <div>
                      <p className="font-medium text-gray-800">打印课程表</p>
                      <p className="text-sm text-gray-600">高质量打印，保持原始样式（不带背景）</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 快捷操作 */}
              <div className="bg-gradient-to-br from-gray-50 to-slate-50 p-6 rounded-xl border border-gray-200">
                <div className="flex items-center mb-4">
                  <MousePointer className="text-gray-600 mr-3" size={20} />
                  <h3 className="text-gray-800 text-xl font-bold">快捷操作</h3>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <p className="text-sm font-medium text-gray-800">左键点击</p>
                    <p className="text-xs text-gray-600">编辑内容</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <p className="text-sm font-medium text-gray-800">右键点击</p>
                    <p className="text-xs text-gray-600">更多选项</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <p className="text-sm font-medium text-gray-800">拖拽移动</p>
                    <p className="text-xs text-gray-600">调整位置</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <p className="text-sm font-medium text-gray-800">回车保存</p>
                    <p className="text-xs text-gray-600">Esc取消</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 底部提示 */}
          <div className="mt-8 bg-gradient-to-r from-blue-100 to-purple-100 p-4 rounded-lg border border-blue-200">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 animate-pulse"></div>
              <p className="text-blue-800 font-medium">
                提示：所有数据会自动保存到浏览器本地存储，刷新页面后数据不会丢失
              </p>
            </div>
          </div>
        </div>
        
        <div className="modal-footer bg-gray-50 rounded-b-xl">
          <button className="btn btn-primary" onClick={onClose}>
            <Check size={16} className="mr-2" />
            开始使用
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
